export enum SchedulerType {
  EVERYDAY = 'EVERYDAY',
  CUSTOM = 'CUSTOM',
}
export enum SchedulerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export enum SchedulerLogStatus {
  PROCESSING = '1',
  DONE = '2',
  TIMEOUT = '3',
  FAILED = '4',
  WARN = '5',
  PENDING = '6',
}
export enum SchedulerOrderStatus {
  PROCESSING = '1',
  DONE = '3',
  TIMEOUT = '4',
  FAIL = '5',
  WARN = '6',
  PENDING = '7', //wait for user paid the order
}
export enum SchedulerSupportedType {
  G_DRIVE = 'G_DRIVE',
  DROP_BOX = 'DROP_BOX',
}
export const weekDays = [
  {value: 'MON', label: 'Scheduler.WEEKDAY.MONDAY'},
  {value: 'TUE', label: 'Scheduler.WEEKDAY.TUESDAY'},
  {value: 'WED', label: 'Scheduler.WEEKDAY.WEDNESDAY'},
  {value: 'THU', label: 'Scheduler.WEEKDAY.THURSDAY'},
  {value: 'FRI', label: 'Scheduler.WEEKDAY.FRIDAY'},
  {value: 'SAT', label: 'Scheduler.WEEKDAY.SATURDAY'},
  {value: 'SUN', label: 'Scheduler.WEEKDAY.SUNDAY'},
]

export const TIME_OPTIONS = Array.from({length: 24 * 6}, (_, i) => {
  const hour = Math.floor(i / 6)
  const minute = (i % 6) * 10
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
})
export const GOOGLE_DRIVE_LINK_PREFIX = 'https://drive.google.com/drive/folders/'
